import angular from 'angular'
import deductionCheck from './deductionCheck'

export default angular
    .module('app.deductionCheck', [])
    .directive('deductionCheck', deductionCheck)
    .name



// WEBPACK FOOTER //
// ./src/components/deductionCheck/index.js